import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {BrowserUtil} from '../../utils/browser.util';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {AutoInvestComponent} from './auto-invest.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {DoughnutModule} from '../../doughnut/doughnut.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import {AutoInvestRoutingModule} from './auto-invest-routing.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {RatingSelectorModule} from '../rating-selector/rating-selector.module';
import {FullPageLoaderModule} from '../../full-page-loader/full-page-loader.module';
import {AutoInvestLoansComponent} from './auto-invest-loans/auto-invest-loans.component';
import {AutoInvestHeaderComponent} from './auto-invest-header/auto-invest-header.component';
import {PortfolioCreationDataResolver} from '../resolvers/portfolio-creation-data-resolver';
import {SelectedPreferencesModule} from '../selected-preferences/selected-preferences.module';
import {AutoPartialInvestComponent} from './auto-partial-invest/auto-partial-invest.component';
import {AutoInvestNoLoansComponent} from './auto-invest-no-loans/auto-invest-no-loans.component';
import {RateOfReturnTooltipModule} from '../../rate-of-return-tooltip/rate-of-return-tooltip.module';
import {AutoInvestLoanViewModelMapper} from './auto-invest-loans/auto-invest-loan-view-model-mapper';
import {PortfolioPreferencesPickerModule} from '../../portfolio-preferences-picker/portfolio-preferences-picker.module';
import {IndianCurrencyFormatterModule} from '../../views/common/indian-currency-formatter/indian-currency-formatter.module';

const customModules = [CommonSectionsModule, RateOfReturnTooltipModule, DoughnutModule,
    IndianCurrencyFormatterModule, SelectedPreferencesModule, RatingSelectorModule, FullPageLoaderModule,
    PortfolioPreferencesPickerModule];
const materialModules = [MatCheckboxModule, MatButtonModule, MatProgressSpinnerModule, MatTableModule,
    MatSortModule, MatPaginatorModule, MatDialogModule];

@NgModule({
    providers: [AutoInvestLoanViewModelMapper, BrowserUtil, PortfolioCreationDataResolver],
    imports: [AutoInvestRoutingModule, CommonModule, FormsModule, ...materialModules, ...customModules],
    declarations: [AutoInvestComponent, AutoPartialInvestComponent, AutoInvestLoansComponent,
        AutoInvestHeaderComponent, AutoInvestNoLoansComponent]
})
export class AutoInvestModule {
}